import React from 'react';

const Navigation: React.FC = () => {
  return (
    <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-red-500 to-blue-500 fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3 ml-0">
            <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
              <img 
                src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                alt="ESPECTÁCULOS BRONCHÚ Logo" 
                className="h-14 w-14 rounded-lg shadow-lg object-cover"
              />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white tracking-widest drop-shadow-2xl" style={{fontFamily: 'Playfair Display, serif', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                ESPECTÁCULOS BRONCHÚ
              </h1>
              <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em', fontFamily: 'Playfair Display, serif'}}>
                L'ART DEL FOC I EL SO
              </p>
            </div>
          </div>

          {/* Navigation Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              INICIO
            </a>
            <a href="/pirotecnia" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              FUEGOS ARTIFICIALES
            </a>
            <a href="/eventos" className="text-white hover:text-red-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              EVENTOS
            </a>
            <a href="/videos" className="text-white hover:text-blue-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              VIDEOS
            </a>
            <a href="/calendario" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              CALENDARIO
            </a>
            <a href="/merchandising" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              MERCHANDISING
            </a>
            <a href="/nosotros" className="text-white hover:text-red-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              NOSOTROS
            </a>
            <a href="/contacto" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
              CONTACTO
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button className="text-white p-2">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
